import React from "react";

export const RelatedOrderContext = React.createContext({
  mainOrder: null,
  gotoNextAssignedOrder: null
});
